import { render, staticRenderFns } from "./NaviTest.vue?vue&type=template&id=d2a5032c&scoped=true"
import script from "./NaviTest.vue?vue&type=script&lang=js"
export * from "./NaviTest.vue?vue&type=script&lang=js"
import style0 from "./NaviTest.vue?vue&type=style&index=0&id=d2a5032c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a5032c",
  null
  
)

export default component.exports